import { Box, Grid } from '@mui/material';
import Dropdown from 'Components/FormControls/Dropdown';
import Input from 'Components/FormControls/Input';
import MultiSelect from 'Components/FormControls/MultiSelect';
import {
  educacionUniversity,
  optionsRequestForm,
  REGIONAL_EDUCATION_MEETING_REQUEST,
  US_EDUCATION_MATERIAL_HANDS_ON_REQUEST_FORM
} from 'Helpers/constant';
import { formatFormName } from 'Helpers/utils';
import { t } from 'i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import ApproverEmailForm from './ApproverEmailForm';

const ApproverForm = ({ isEditing, formTypeList }) => {
  const { control, setValue } = useFormContext();
  const { regionListeData } = useSelector((state) => state.approver);

  const transformedRegionList =
    Array.isArray(regionListeData) && regionListeData.length > 0
      ? regionListeData.map((region) => ({
          id: region.id,
          name: region.regionName
        }))
      : [];

  const raw_form_id = useWatch({ control, name: 'form_id' });
  const form_id = formTypeList?.find((form) => form.id === raw_form_id)?.formType || '';
  const field = useWatch({ control, name: 'field' });

  const formattedOptions = formTypeList?.map((option) => ({
    ...option,
    name: formatFormName(option.formType),
    value: option.id
  }));

  const handleFormChange = () => {
    setValue('field', '');
    setValue('field_university_request', '');
    setValue('region', []);
  };

  const handleFieldChange = () => {
    setValue('field_university_request', '');
    setValue('region', []);
  };

  return (
    <>
      <Box className="add-section-approver">
        <Grid container spacing={2} columnSpacing={2} className="input-group-container mb-2">
          <Grid item xs={12} className="add-section-title">
            {t('approverManagement.requestFormTitle')}
          </Grid>
          <Grid item xs={12} sm={8} className="input-container">
            <Dropdown
              name="form_id"
              options={formattedOptions}
              label={t('approverManagement.requestFormName')}
              placeholder={t('form.select')}
              handleChange={handleFormChange}
              required
              disabled={isEditing}
              valueData={true}
            />
          </Grid>
        </Grid>
        {form_id === US_EDUCATION_MATERIAL_HANDS_ON_REQUEST_FORM && (
          <>
            <Grid container spacing={2} columnSpacing={2} className="input-group-container mb-2">
              <Grid item xs={12} sm={8} className="input-container">
                <Dropdown
                  name="field"
                  options={optionsRequestForm}
                  label={t('admin.requestFormApprover.field')}
                  placeholder={t('form.select')}
                  handleChange={handleFieldChange}
                  required
                  disabled={isEditing}
                />
              </Grid>

              {field === 'HCP Proctor/University Faculty' && (
                <Grid item xs={12} sm={8} className="input-container">
                  <Dropdown
                    name="field_university_request"
                    options={educacionUniversity}
                    label={t('admin.requestFormApprover.educationType')}
                    placeholder={t('form.select')}
                    required
                    disabled={isEditing}
                  />
                </Grid>
              )}
            </Grid>
          </>
        )}

        {form_id === REGIONAL_EDUCATION_MEETING_REQUEST && (
          <>
            <Grid container spacing={2} columnSpacing={2} className="input-group-container mb-2">
              <Grid item xs={12} sm={8} className="input-container">
                <MultiSelect
                  name="regions"
                  options={transformedRegionList || []}
                  label={t('admin.requestFormApprover.region')}
                  placeholder={t('form.select')}
                  useHookForm={true}
                  required
                  disabled={isEditing}
                />
              </Grid>
            </Grid>
          </>
        )}
        <Grid container spacing={2} columnSpacing={2} className="input-group-container mb-2">
          <Grid item xs={12} sm={6} className="input-container">
            <Input
              name="approverName"
              label={t('approverManagement.approverName')}
              placeholder={t('approverManagement.approverName')}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6} className="input-container">
            <Input
              name="approverEmail"
              label={t('approverManagement.approverEmailAddress')}
              placeholder={t('form.email')}
              required
            />
          </Grid>
        </Grid>
      </Box>

      <ApproverEmailForm isEditing={isEditing} />
    </>
  );
};

export default ApproverForm;
